// extracted by mini-css-extract-plugin
export default {"button":"BackToHome_button__c6RQW","circle":"BackToHome_circle__nD3o-","text":"BackToHome_text__4-+ZQ"};